import GreatPrice from "./images/great-price.svg";
import InstantPayment from "./images/instant-payment.svg";
import hassleFreeDocumentation from "./images/hassle-free-documentation.svg";
import sellAnywhere from "./images/sell-anywhere.svg";
export const STEPS = [
    {
        img: GreatPrice,
        title: "Great ",
        subTitle: "price",
        description: "Largest dealer network + Smart AI Pricing Engine = great deal for your car"
    },
    {
        img: InstantPayment,
        title: "Instant",
        subTitle: "payment",
        description: "The amount is transferred directly to your bank account within minutes"
    },
    {
        img: hassleFreeDocumentation,
        title: "Hassle-free ",
        subTitle: "documentation",
        description: "Documentation and RC transfers can take months! We’ll handle it all"
    },
    {
        img: sellAnywhere,
        title: "Sell from",
        subTitle: "anywhere",
        description: "From inspection to payment, everything right from your doorstep!"
    }
];
